
import { defineComponent, ref, onMounted } from "vue";
import { usePlugin } from "@/plugins";
import {
  NotificationLog,
  GetNotificationLogRequest,
  GetNotificationLogResponse,
} from "@/types";

export default defineComponent({
  name: "Notification Log",
  setup() {
    const notificationLogs = ref<NotificationLog[]>([]);
    const notificationLog = ref<NotificationLog>();
    const dates = ref<Date[]>([]);
    const userId = ref("");
    const showDialog = ref(false);
    const message = ref();

    const {
      axios,
      error,
      success,
      dayjs,
      setLoading,
      formatAppDateTime,
    } = usePlugin();

    const loadLogs = async () => {
      setLoading(true);
      try {
        var result = await axios.post<GetNotificationLogResponse>(
          "api/v1/services/notificationLogs/get",
          {
            dates: dates.value,
            userId: userId.value,
          } as GetNotificationLogRequest
        );
        notificationLogs.value = result.data.logs ?? [];
        success("ดึงข้อมูลสำเร็จแล้ว");
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };

    const popupDetail = (log: NotificationLog) => {
      notificationLog.value = log;
      showDialog.value = true;
      message.value = JSON.parse(
        notificationLog.value.message.replaceAll('\\"', '"')
      );
    };

    onMounted(async () => {
      dates.value = [
        dayjs()
          .add(-7, "day")
          .toDate(),
        dayjs()
          .add(7, "day")
          .toDate(),
      ];
      await loadLogs();
    });

    return {
      notificationLogs,
      dates,
      userId,
      loadLogs,
      formatAppDateTime,
      notificationLog,
      popupDetail,
      showDialog,
      message,
    };
  },
});
